import { render } from "./MarketingAssessment.vue?vue&type=template&id=b3db8212&scoped=true"
import script from "./MarketingAssessment.vue?vue&type=script&lang=js"
export * from "./MarketingAssessment.vue?vue&type=script&lang=js"

import "./MarketingAssessment.vue?vue&type=style&index=0&id=b3db8212&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b3db8212"]])

export default __exports__